import React, {createContext, useCallback, useContext, useEffect, useState} from 'react'
import {alert, getLocalstorage, setLocalstorage} from '@/utils/utils'
import {getUserInfo} from '@/utils/common'
import * as commonApi from '@/api/common'
import * as api from '@/api/user'
import * as order from '@/api/order'
import {exportExcel} from "@/api/cpyfcgj";

export const pathConstent = {
    GWC: 'gwc',
    QPLCP: 'qplcp'
}

export const jcContent = {
    JGQX: 'jgqx'
}

const Context = createContext<{
    userInfo: any
    baseInfo: any
    shopcarCount: number
    zmdddCount: number
    inventoryClass: any[]
    inventoryClassNew: any[]
    updateUserInfo: (data: any) => void
    updateBaseInfo: () => void
    updateFxsBaseInfo: () => void
    clear: () => void
    updateShopCarCount: () => void
    updateZmdddCount: () => void
    updateInventoryClass: () => void
    hasPermission: (key: string) => boolean
    hasJcPermission: (key: string) => boolean
}>({
    userInfo: {},
    baseInfo: {},
    shopcarCount: 0,
    zmdddCount: 0,
    inventoryClass: [],
    inventoryClassNew: [],
    updateUserInfo() {
    },
    updateBaseInfo() {
    },
    updateFxsBaseInfo() {
    },
    clear() {
    },
    updateShopCarCount() {
    },
    updateZmdddCount() {
    },
    updateInventoryClass() {
    },
    hasPermission() {
        return false
    },
    hasJcPermission() {
        return false
    }
})

// 将权限树转为一维数组
const transformQx = (items) => {
    if (!items) {
        return []
    }
    let res = items.map(item => ({
        ...item,
        // 如果存在子节点，则当前节点为目录，将地址清空
        hmtzdz: item.children && item.children.length > 0 ? null : item.hmtzdz,
        children: null
    }))
    items.forEach((item) => {
        res = [...res, ...transformQx(item.children)]
    })
    return res
}

export const UserInfoProvider = ({children}) => {
    const [userInfo, setUserInfo] = useState({})
    const [baseInfo, setBaseInfo] = useState<any>({})
    const [shopcarCount, setShopcarCount] = useState(0)
    const [zmdddCount, setZmdddCount] = useState(0)
    const [done, setDone] = useState(false)
    const [inventoryClass, setInventoryClass] = useState([])
    const [inventoryClassNew, setInventoryClassNew] = useState([])

    // 清空登录
    const clear = useCallback(() => {
        setBaseInfo({})
        setUserInfo({})
        setLocalstorage('userinfo', null)
        setLocalstorage('baseinfo', null)
        setShopcarCount(0)
        setZmdddCount(0)
    }, [])

    // 更新基本数据
    const updateBaseInfo = useCallback(async () => {
        const userInfo = getUserInfo()
        if (!userInfo) {
            return
        }
        let res;
        if(userInfo.lx==='ZMJFXS' || userInfo.lx==='FZMJFXS') {
            res = await api.getFxsCurrentUser();
        } else {
            res = await api.getCurrentUser();
         }
        console.log(res)
        if (res && res.userid) {
            if (res.userid === "-1") {
                alert("提示信息", res.msg, () => {
                    clear()
                    window.location.reload()
                })
                return
            }
            // 更新本地缓存登录数据到状态
            const userInfo = getLocalstorage('userinfo')
            setUserInfo(userInfo)
            // 更新用户数据
            setBaseInfo({
                ...res,
                webqxList: res.qx && res.qx.webqx ? transformQx(JSON.parse(res.qx.webqx)) : [],
                ppqxList: res.qx && res.qx.ppqx ? transformQx(JSON.parse(res.qx.ppqx)) : [],
                jcqx: res.qx && res.qx.jcqx ? JSON.parse(res.qx.jcqx) : {}
            })
            setLocalstorage('baseinfo', res)
            setDone(true)
        } else {
            alert("提示信息", res && res.msg || '获取用户信息失败', () => {
                clear()
                window.location.reload()
            })
        }
    }, [clear])


    // 更新基本数据
    const updateFxsBaseInfo = useCallback(async () => {
        const userInfo = getUserInfo()
        if (!userInfo) {
            return
        }
        const res = await api.getFxsCurrentUser()
        console.log(res)
        if (res && res.userid) {
            if (res.userid === "-1") {
                alert("提示信息", res.msg, () => {
                    clear()
                    window.location.reload()
                })
                return
            }
            // 更新本地缓存登录数据到状态
            const userInfo = getLocalstorage('userinfo')
            setUserInfo({
                ...userInfo,
                ...res
            })
            // 更新用户数据
            setBaseInfo({
                ...res,
                webqxList: res.qx && res.qx.webqx ? transformQx(JSON.parse(res.qx.webqx)) : [],
                ppqxList: res.qx && res.qx.ppqx ? transformQx(JSON.parse(res.qx.ppqx)) : [],
                jcqx: res.qx && res.qx.jcqx ? JSON.parse(res.qx.jcqx) : {}
            })
            setDone(true)
        } else {
            alert("提示信息", res && res.msg || '获取用户信息失败', () => {
                clear()
                window.location.reload()
            })
        }
    }, [clear])

    const updateShopCarCount = useCallback(async () => {
        try {
            const userinfo = getUserInfo()
            if (userinfo && userinfo.sysid) {
                const baseInfoOne = getLocalstorage('baseinfo')
                const result = await api.getShopCarCount(baseInfoOne)
                if (result.success) {
                    setShopcarCount(result.data.sl || 0)
                }
            }
        } catch(e) {
            alert('购物车更新失败', JSON.stringify(e))
        }
    }, [])

    const updateZmdddCount = useCallback(async () => {
        try {
            const userInfo = getUserInfo()
            if (userInfo && userInfo.sysid) {
                return order.getZmdJxslist({
                    partner:userInfo.jxsxx.partner,
                    xdrq: undefined,
                    shoudf: userInfo.jxsxx.partner,
                    spf: userInfo.jxsxx.partner,
                    ddlx:"专卖店订单",
                    zt:'待经销商确认'
                }).then((res) => {
                        setZmdddCount(res.data.length)
                })
            }
        } catch(e) {
            alert('代发运订单更新失败', JSON.stringify(e))
        }
    }, [])

    const updateUserInfo = useCallback(async (data) => {
        setUserInfo(data)
        setLocalstorage('userinfo', data)
        updateBaseInfo()

    }, [updateBaseInfo])

    const updateInventoryClass = useCallback(async () => {
        const userinfo = getUserInfo()
        if (!userinfo) {
            return
        }
        const res = await commonApi.inventoryClass()
        if (res.status) {
            setInventoryClass(res.data || [])
            setInventoryClassNew((res.data || []))
        }
    }, [])

    useEffect(() => {
        const userInfo = getLocalstorage('userinfo')
        setUserInfo(userInfo)
        updateShopCarCount()
        updateZmdddCount()
        if (userInfo) {
            updateBaseInfo()
        } else {
            setDone(true)
        }
    }, [updateBaseInfo, updateShopCarCount, updateZmdddCount])

    const hasPermission = useCallback((key: string) => {
        return (baseInfo.webqxList || []).some(qx => qx.hmtzdz === key || qx.hmbh === key)
    }, [baseInfo])

    const hasJcPermission = useCallback((key: string) => {
        return baseInfo.jcqx[key] === '1'
    }, [baseInfo.jcqx])

    useEffect(() => {
        updateInventoryClass()
    }, [updateInventoryClass])

    return (
        <Context.Provider value={{
            inventoryClassNew,
            shopcarCount,
            zmdddCount,
            baseInfo,
            userInfo,
            inventoryClass,
            hasJcPermission,
            hasPermission,
            updateUserInfo,
            updateBaseInfo,
            updateFxsBaseInfo,
            clear,
            updateShopCarCount,
            updateZmdddCount,
            updateInventoryClass
        }}>
            {done && children}
        </Context.Provider>
    );
}

export const useUserInfoContext = () => {
    return useContext(Context)
}

export default Context